import * as React from "react";

import "./marketing-center-layout.scss";

import {MarketingCenterMenuDesktop}                     from "../desktop/menu-desktop/marketing-center-menu-desktop";
import {MarketingCenterMenuMobile}                      from "../mobile/menu-mobile/marketing-center-menu-mobile";
import {SubHeader}                                      from "../../common/sub-header/sub-header";
import {Layout}                                         from "../../layout/layout";
import {cs}                                             from "@Common/react/chain-services";
import {consumeContext}                                 from "@Common/react/context";
import {Load2}                                          from "@Common/react/load2";
import {UseState}                                       from "@Common/react/use-state";
import {MEDIA_QUERY_MD, ViewportTest}                   from "@Common/ui-components/viewport-test";
import {faBuildingUser, faCircleUser}                   from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon}                                from "@fortawesome/react-fontawesome";
import {CompanyUserIcon}                                from "@Xpresso/routes/common/company-user-icon";
import {USER_LEVEL, OFFICE_LEVEL, COMPANY_LEVEL}        from "@Xpresso/routes/common/logic/user-level";
import {marketingCenterLinks}                           from "@Xpresso/routes/marketing-center/common/marketing-center-common";

export const MarketingCenterLayout = () => cs(
    consumeContext("apis"),
    consumeContext("company"),
    consumeContext("session"),
    consumeContext("systemConstants"),
    consumeContext("themeScheme"),
    consumeContext("userLevels"),
    ["profile", ({userLevels, session, company}, next) => next(profileObject(userLevels, company, session))],
    ["helpMgmt", ({apis}, next) => Load2({
        fetch: () => apis.next.helpMgmt.getHelpMgmt(),
        next,
    })],
    ["linkActive", ({}, next) => UseState({
        initValue: marketingCenterLinks[0],
        next,
    })],
    ({profile, helpMgmt, linkActive, themeScheme, systemConstants}) => Layout({
        active: "profile",
        className: "marketing-center-layout-AlO3",
        children: (
            <ViewportTest
                if={MEDIA_QUERY_MD}
                then={() => showMobileView({helpMgmt, linkActive, url: systemConstants.value?.BLOG_URL})}
                else={() => showDesktopView({profile, helpMgmt, linkActive, themeScheme, url: systemConstants.value?.BLOG_URL})}
            />
        )
    })
);

const subHeaderObject = {
    backLink: {
    to: "/",
    label: "Home",
    },
    title: "Marketing Center",
}

const showDesktopView = ({profile, helpMgmt, linkActive, themeScheme, url}) => (
    <div className="marketing-center-layout-desktop">
        {SubHeader(subHeaderObject)}
        <div className="main">
            {MarketingCenterMenuDesktop({profile, helpMgmt, linkActive, url})}
            <div className="content">
                <iframe className="iframe"
                    id="iframe-id"
                    style={{height: themeScheme.xpresso.headerBanner ? "63vh" : "72vh"}}
                    title="Blog Iframe"
                    src={url}
                />
            </div>
        </div>
    </div>
)

const showMobileView = ({helpMgmt, linkActive, url}) => (
    <div className="marketing-center-layout-mobile">
        {SubHeader(subHeaderObject)}
        <div className="main">
            {MarketingCenterMenuMobile({helpMgmt, linkActive, url})}
            <div className={"content"}>
                <iframe className="iframe"
                    id="iframe-id"
                    title="Blog Iframe"
                    src={url}
                />
            </div>
        </div>
    </div>
)

const profileObject = (userLevels, company, session) => {
    switch(userLevels.userLevel) {
        case COMPANY_LEVEL:
            return {
                label: company?.companyName,
                icon: CompanyUserIcon({}),
            }

        case OFFICE_LEVEL:
            return {
                label: session.data?.branchName,
                subLabel: company?.companyName,
                icon: <FontAwesomeIcon className="icon1" icon={faBuildingUser}/>,
            }

        case USER_LEVEL:
        default:
            return {
                label: session?.data?.agentNameLast && session?.data?.agentNameFirst + " " + session?.data?.agentNameLast,
                subLabel: session.data?.branchName,
                icon: session?.data?.agent?.imageGallery?.headshots[0]?.thumbnailUrl ? (
                    <img
                        src={session?.data?.agent?.imageGallery?.headshots[0]?.thumbnailUrl}
                        alt={session?.data?.agentNameLast && session?.data?.agentNameFirst + " " + session?.data?.agentNameLast}
                    />
                ) : (
                    <FontAwesomeIcon className="icon1" icon={faCircleUser}/>
                ),
            }
    }
}
